<template>
    <div class="tw-cell-edit">
        <component :is="componentName" :key="componentName" v-model="text" :data_source="data_source" :caption_name="caption_name" :value_name="value_name" :readonly="readonly || disAllowEdit" @onQuery="onQuery" v-if="!column.binding || (column.binding && Object.keys(data_source).length)" style="width: -webkit-fill-available;">
        
        </component>

        <!-- 扩展按钮 -->
        <span class="p-buttonset tw-buttonset">
            <Button class="p-button-sm" v-for="item in buttons" :key="item.event_no" :label="item.button_caption" :icon="item.button_icon" v-show="item.enabled && (((readonly || disAllowEdit) && item.visible_browsing) || (!readonly && !disAllowEdit && item.visible_editing))" @click="btnClick(item.event_no)" />
        </span>
    </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import messageService from '../../services/message.service'
import Button from 'primevue/button';

export default {
    name: 'tw-cell-edit',
    components: {
        Button
    },
    setup(props, context) {
        const text = computed({
            get() {
                if(props.dataRow && props.column){
                    if(props.column.binding && props.column.control_type !== "tw-input"){
                        return data_source.value?.datas.find(el => el[props.column.binding.display_field] === props.dataRow[props.column?.field_name])
                    }else{
                        return props.dataRow[props.column?.field_name]
                    }
                }else{
                    return null
                }
            },

            set(value){
                if(props.dataRow && props.column){
                    if(props.column.binding && props.column.control_type !== "tw-input"){
                        const select_row = data_source.value?.datas.find(el => el === value)

                        if(select_row){
                            props.column.binding.setValues(props.dataRow, select_row)
                        }else{
                            messageService.warn('请设置好数据源显示字段')
                        }
                    }else if(props.column.binding && props.column.control_type === "tw-input") {
                        const select_row = data_source.value?.datas.find(el => el[props.column?.field_name] === value)

                        if(select_row){
                            props.column.binding.setValues(props.dataRow, select_row)
                        }
                    }else{
                        const temp = props.dataRow;
                        temp[props.column.field_name] = value;

                        context.emit('update:dataRow', temp)
                    }
                }
            }
        })
        
        const componentName = computed(() => {
            const controlType = props.column && props.column.control_type
            // switch (controlType) {
            //     case 'datepicker':
            //         return 'tw-date-picker';
            //     case 'checkbox':
            //         return 'tw-checkbox'
            //     case 'dropdown':
            //         return 'tw-dropdown';
            //     case 'combobox':
            //         return 'tw-dropdown';
            //     case 'text':
            //         return 'tw-input';
            //     default:
            //         return 'tw-input';
            // }
            // 改为直接使用控件类型（类型即为组件名）
            return controlType ?? 'tw-input'
        })

        const disAllowEdit = computed(() => {
            const allowEdit = (props.column && props.column.allow_edit) ?? true;
            return !allowEdit
        })

        const buttons = computed(() => {
            return props?.column?.buttons ?? []
        })

        const caption_name = ref();
        const value_name = ref();
        const data_source = ref({});

        onMounted(async () => {
            if(props.column.binding){
                caption_name.value = props.column.binding.display_field
                // value_name.value = props.column.binding.value_field
                value_name.value = ''   // 使得下拉组件的值为对象
                data_source.value = await props.column.binding.getDataSource(props.dataRow, {})
            }
        })

        // 【tw-input】查询
        const onQuery = async (keyword) => {
            data_source.value = await props.column.binding.getDataSource(props.dataRow, { keyword: keyword })
        }

        // 拓展按钮
        const btnClick = (event_no) => {
            context.emit('btnClick', { event_no })
        }

        return {
            componentName,
            disAllowEdit,
            text,
            data_source,
            caption_name,
            value_name,
            onQuery,
            buttons,
            btnClick
        }
    },
    props: {
        dataRow: null,
        column: null,
        readonly: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style>

</style>